/**
 * Created by jv on 16/05/2017.
 */
const utils = require("Sources/utils/utils");

const ANIMATION_DURATION = 300;

module.exports = class DialogTemplate
{
  constructor(options)
  {
    if(utils.isNull(options))
    {
      throw "options must be defined";
    }

    this.dialogId = utils.isNotNull(options.dialogId) ? options.dialogId : utils.generateUIDShort();
    this.backdropIdSuffix = "-modal-backdrop";
    this.title = options.title;
    this.dialogContent = options.dialogContent;
    this.disposable = utils.isBoolean(options.disposable) ? options.disposable : true;

    this.confirmText = options.confirmText;
    this.cancelText = options.cancelText;
    this.cancelTopRight = utils.isBoolean(options.cancelTopRight) ? options.cancelTopRight : false;

    this.onConfirm = options.onConfirm;
    this.onCancel = options.onCancel;
    this.onDispose = options.onDispose;

    this.create();
  }

  create()
  {
    if(this._initialized !== true)
    {
      this.renderDialog();

      this.backdrop = "<div id='" + this.backdropId + "' class='modal-backdrop fade show'></div>";

      this.dialogEl.appendTo("body");

      if(this.disposable)
      {
        this.addDisposeListener();
      }

      this._initialized = true;
    }
  }

  renderDialog()
  {
    this.dialogEl = $("<div id='" + this.dialogId + "' class='modal fade' style='display: block;'>" +
                        "<div class='modal-dialog'>" +
                          "<div class='modal-content clearfix'>" +
                          "</div>" +
                        "</div>" +
                      "</div>");

    this.renderDialogHeader();
    this.renderDialogContent();
    this.renderDialogFooter();
  }

  renderDialogHeader()
  {
    var dialogContentEl = this.dialogEl.find(".modal-content");

    if(utils.isNotNull(dialogContentEl) && dialogContentEl.length)
    {
      var dialogHeader = "<div class='modal-header'><h4 class='dialog-title'>" + this.title + "</h4></div>";
      dialogContentEl.append(dialogHeader);
    }
  }

  renderDialogContent()
  {
    var dialogContentEl = this.dialogEl.find(".modal-content");

    if(utils.isNotNull(dialogContentEl) && dialogContentEl.length)
    {
      var dialogBodyEl = $("<div class='modal-body'></div>");
      dialogBodyEl.append(this.dialogContent);

      dialogContentEl.append(dialogBodyEl);
    }
  }

  renderDialogFooter()
  {
    var that = this;
    var dialogContentEl = that.dialogEl.find(".modal-content");

    if(utils.isNotNull(dialogContentEl) && dialogContentEl.length)
    {
      var dialogFooterEl = $("<div class='modal-footer'></div>");

      if(utils.isNotNull(that.confirmText))
      {
        var confirmBtn = $("<button class='btn btn-primary dialog-confirm-btn' type='button'>" + that.confirmText + "</button>");

        confirmBtn.on("click", function(e)
        {
          if(utils.isFunction(that.onConfirm))
          {
            that.onConfirm();
          }
        });

        dialogFooterEl.append(confirmBtn)
      }

      if(utils.isNotNull(that.cancelText) || that.cancelTopRight === true)
      {
        var classNames = "btn btn-primary dialog-cancel-btn";
        var innerHTML = that.cancelText;

        if(that.cancelTopRight)
        {
          classNames = "btn btn-icon frameless cross-circle dark-grey pull-right";
          innerHTML = "";
        }

        var cancelBtn = $("<button class='" + classNames + "' type='button'>" + innerHTML +"</button>")

        cancelBtn.on("click", function()
        {
          that.cancel();
        });

        if(that.cancelTopRight)
        {
          that.dialogEl.find(".modal-content").prepend(cancelBtn);
        }
        else
        {
          dialogFooterEl.append(cancelBtn);
        }
      }

      dialogContentEl.append(dialogFooterEl);
    }
  }

  destroy()
  {
    var that = this;

    if(utils.isNotNull(that.dialogEl) && that.dialogEl.length && that._destroying !== true)
    {
      that._destroying = true;

      that.hide(function()
      {
        that.dialogEl.remove();
        that._initialized = false;
        that._destroying = false;
      });
    }
  }

  show()
  {
    var $body = $("body");
    if(!$body.hasClass("modal-open"))
    {
      $body.addClass("modal-open");
    }

    if(!this.backdropExists)
    {
      $body.append(this.backdrop);
    }

    // Reading a css property forces layout to be computed
    this.dialogEl.show().css("width");
    this.dialogEl.addClass("show");
  }

  hide(callback)
  {
    var that = this;
    var $body = $("body");
    if($body.hasClass("modal-open"))
    {
      $body.removeClass("modal-open");
    }

    $("#" + this.backdropId).remove();
    this.dialogEl.removeClass("show");

    setTimeout(function()
    {
      that.dialogEl.hide();
      if(utils.isFunction(callback))
      {
        callback();
      }
    }, ANIMATION_DURATION);
  }

  cancel()
  {
    this.hide();

    if(utils.isFunction(this.onCancel))
    {
      this.onCancel();
    }
  }

  dispose()
  {
    this.hide();

    if(utils.isFunction(this.onDispose))
    {
      this.onDispose();
    }
  }

  get backdropId()
  {
    return this.dialogId + this.backdropIdSuffix;
  }

  get backdropExists()
  {
    return $("#" + this.backdropId).length;
  }

  addDisposeListener()
  {
    var that = this;

    that.dialogEl.off().on("click", function(e)
    {
      if(e.target.className === "modal-content" || $(e.target).closest(".modal-content").length)
      {
        e.stopPropagation();
        return;
      }

      that.dispose();
    });
  }
}



// WEBPACK FOOTER //
// ./app/js/templates/dialog.template.js